module.exports={render:function (){
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "data-vv-scope": _vm.fieldData.name
    }
  }, [_c('div', {
    class: ['form-group', ( _obj = {}, _obj['has-error'] = _vm.errors.first(_vm.field.name + '-source-form-id', _vm.fieldData.name), _obj )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-form-id'
    }
  }, [_vm._v("Source form name*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.formId),
      expression: "field.formId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-form-id',
      "data-vv-name": _vm.fieldData.name + '-source-form-id'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "formId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateFormFields]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.forms), function(form) {
    return (form.id !== _vm.formId) ? _c('option', {
      domProps: {
        "value": form.id
      }
    }, [_vm._v(_vm._s(form.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSourceFormRangeSelectVisible),
      expression: "isSourceFormRangeSelectVisible"
    }],
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': _vm.field.formData == 'daterange',
      'col-lg-12': _vm.field.formData != 'daterange'
    }
  }, [_c('div', {
    class: ['form-group', ( _obj$1 = {}, _obj$1['has-error'] = _vm.errors.first(_vm.field.name + '-source-form-data', _vm.fieldData.name), _obj$1 )]
  }, [_c('label', [_vm._v("Source forms range*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.formData),
      expression: "field.formData"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-source-form-data',
      "data-vv-name": _vm.fieldData.name + '-source-form-data'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "formData", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 'all'
    }
  }, [_vm._v("All filled forms")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'last'
    }
  }, [_vm._v("Most recent entry")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'daterange'
    }
  }, [_vm._v("Completed At Date range")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'daterange-field'
    }
  }, [_vm._v("Field Date range")])])])]), _vm._v(" "), (_vm.field.formData == 'daterange-field') ? _c('div', {
    staticClass: "col-lg-6 margin-bottom-15"
  }, [_c('div', {
    class: ['form-group', ( _obj$2 = {}, _obj$2['has-error'] = _vm.errors.first(_vm.field.name + '-daterange-field', _vm.fieldData.name), _obj$2 )]
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-daterange-field'
    }
  }, [_vm._v("Date field*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.dateRangeField),
      expression: "field.dateRangeField"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name + '-daterange-field',
      "data-vv-name": _vm.fieldData.name + '-daterange-field'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.field, "dateRangeField", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.formFields), function(value) {
    return (value.name.includes('date')) ? _c('option', {
      domProps: {
        "value": value.name
      }
    }, [_vm._v("[" + _vm._s(value.label) + "] " + _vm._s(value.description))]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (['daterange', 'daterange-field'].includes(_vm.field.formData)) ? _c('div', {
    staticClass: "col-lg-6 margin-bottom-15"
  }, [_c('div', {
    class: ['form-group', ( _obj$3 = {}, _obj$3['has-error'] = _vm.errors.first(_vm.field.name + '-datepicker', _vm.fieldData.name), _obj$3 )]
  }, [_c('label', [_vm._v("Select date range*")]), _vm._v(" "), _c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "input-class": "form-control",
      "placeholder": "Select Date Range",
      "lang": "en",
      "range-separator": "-",
      "format": _vm.calendarFormat,
      "value-type": 'format',
      "range": true,
      "confirm": false,
      "prefix-class": "xmx",
      "data-vv-name": _vm.fieldData.name + '-datepicker'
    },
    model: {
      value: (_vm.field.formDataRange),
      callback: function($$v) {
        _vm.$set(_vm.field, "formDataRange", $$v)
      },
      expression: "field.formDataRange"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.field.formId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.field.name + '-source-field'
    }
  }, [_vm._v("Show fields")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10"
  }, [_vm._l((_vm.formFields), function(field) {
    return [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.showFields),
        expression: "showFields"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": field.name,
        "checked": Array.isArray(_vm.showFields) ? _vm._i(_vm.showFields, field.name) > -1 : (_vm.showFields)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.showFields,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.showFields = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.showFields = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.showFields = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v("[" + _vm._s(field.label) + "] " + _vm._s(field.description) + "\n        ")]), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98c8a708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/atoms/FormBuilderSharedFormPreview.vue
// module id = 1728
// module chunks = 1